import { Directive, ElementRef, OnInit } from '@angular/core'
import { RuntimeService } from 'src/app/service/runtime.service'

@Directive({
  standalone: true,
  selector: 'iframe[autosize]',
})
export class AutosizeIframeDirective implements OnInit {
  constructor (
    protected elementRef: ElementRef<HTMLIFrameElement>,
    protected runtimeService: RuntimeService,
  ) {
  }

  ngOnInit () {
    if (this.runtimeService.isServer()) {
      return
    }

    const method = typeof window.addEventListener !=='undefined'
      ? 'addEventListener'
      : 'attachEvent'
    const messageEvent = method === 'attachEvent'
      ? 'onmessage'
      : 'message'

    // @ts-ignore
    window[method](messageEvent, (event: any) => {
      const params = event.data?.split?.(':')
      if (!params) { return }

      const type = params[0]
      if (type === 'dom-resize') {
        this.elementRef.nativeElement.style.height = params[1]
      }
    })
  }
}
